function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.518 25.736a1.116 1.116 0 01-.647 1.436 1.109 1.109 0 01-1.43-.65 1.116 1.116 0 01.647-1.436 1.109 1.109 0 011.43.65z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.647 2.856A1.005 1.005 0 00.065 4.15a.999.999 0 001.288.585l1.768-.67a.886.886 0 011.146.52l6.345 16.889c-.289.05-.577.13-.861.237-2.47.936-3.716 3.704-2.785 6.183a4.773 4.773 0 006.158 2.796 4.797 4.797 0 003.084-4.2l11.978-4.536a.885.885 0 01.68.022l1.722.781a.998.998 0 001.323-.5c.227-.506.004-1.1-.5-1.33l-1.722-.781a2.879 2.879 0 00-2.21-.07l-11.587 4.388a4.778 4.778 0 00-3.095-2.864L6.138 3.877a2.896 2.896 0 00-1.513-1.62 2.879 2.879 0 00-2.21-.07l-1.768.67zm8.19 24.33a2.793 2.793 0 011.62-3.596 2.775 2.775 0 013.58 1.626 2.793 2.793 0 01-1.619 3.595 2.775 2.775 0 01-3.58-1.626z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.336 14.58a1.005 1.005 0 00-.582 1.293.999.999 0 001.288.585l1.768-.67c.517-.195.778-.774.583-1.293a.999.999 0 00-1.289-.585l-1.768.67z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.015 11.452A2.905 2.905 0 0112.7 7.713l8.839-3.348a2.886 2.886 0 013.723 1.69l3.334 8.876a2.905 2.905 0 01-1.683 3.738l-8.84 3.348a2.886 2.886 0 01-3.722-1.69l-3.335-8.875zm2.39-1.86a.894.894 0 00-.518 1.151l3.334 8.875a.888.888 0 001.146.52l8.839-3.348a.894.894 0 00.518-1.15L23.39 6.764a.888.888 0 00-1.146-.52l-8.84 3.347z",
  fill: "currentColor"
})));